import { DateService } from 'src/app/services/date.service';
import * as $ from 'jquery';
import { DataService } from './../../services/data.service';
import { VmsService } from 'src/app/services/vms.service';
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
export class InviteComponent implements OnInit,OnDestroy {
  openOptionDrawer: boolean = false;
  tempDate: any;
  formattedDate: string;
  today: string;
  response: any;
  constructor(private router: Router, private vmsSrv: VmsService,private dateSrv:DateService) {}
  member: any = [];
  history: any = [];
  // memberDetail: any;
  displayLen:number=5;
  private subscriptions = new Subscription();

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openDrawer(id, item) {
    $('#' + id).find('.drawer-container').toggle();

  }
  hidePopup(){
    $(document).on("click", function () {
      $(".drawer-container").hide();
  });
  }

  navigateToDetail(id) {
    localStorage.setItem('navigate', '1');
    this.router.navigate(['/vms/detail'],{queryParams:{id:id,type:'individual'}});
  }

  navigateToHistory(){
    localStorage.setItem('type','individual-invite')
    this.router.navigate(['/vms/history'])
  }

  reInvite(item){
    this.router.navigate(['/vms/individual-invite/invite'],{queryParams:{id:item}});
  }

  loadData() {
    const jsDate = new Date;
    const data = {
      InvitationType: 'individualInvite',
      ParkId:localStorage.getItem('parkId'),
    };
    this.subscriptions.add(this.vmsSrv.getInvitationList(data).subscribe((res) => {
      this.response=res
      this.today=this.dateSrv.convertDateToLocaleString(jsDate.getDate(),jsDate.getMonth(),jsDate.getFullYear())
      this.member=this.response.filter(res=>this.formatDate(res.mstart,'formatDate')>=this.today)
      this.history=this.response.filter(res=>this.formatDate(res.mstart,'formatDate')<this.today)

    }))
  }

  formatDate(date,type){
  if(date==null) return
  this.tempDate=date.split('T')[0].split('-');
  this.formattedDate=this.dateSrv.convertDateToLocaleString(this.tempDate[2],this.tempDate[1],this.tempDate[0])
  if(type=='date') return this.tempDate[2]
  if(type=='month') return this.formattedDate.split(' ')[1]
  if(type=='format') return this.formattedDate.split(' ')[0]+' '+this.formattedDate.split(' ')[1]+','+this.formattedDate.split(' ')[2]
  if(type=='formatDate') return this.formattedDate
}



cancelInvite(id){
  this.subscriptions.add(this.vmsSrv.cancelInvitation(id).subscribe(res=>{
    console.log(res)
    if(res.isValid) this.loadData();

  }))
}

}
